export class ErrorMessage {
  private _errorCode: number;
  get errorCode(): number {
    return this._errorCode;
  }

  private _errorMessage: string;
  get errorMessage(): string {
    return this._errorMessage;
  }

  private _translationKey: string;
  get translationKey(): string {
    return this._translationKey;
  }

  private constructor(errorCode: number, errorMessage: string, translationKey: string) {
    this._errorCode = errorCode;
    this._errorMessage = errorMessage;
    this._translationKey = translationKey;
  }

  public static readonly genericErrorCode: number = 1;
  public static readonly genericError: ErrorMessage = new ErrorMessage(1, 'General backend error', 'errorMessageGenericBackend');
  public static readonly commonInvalidTokenErrorCode: number = 51;
  public static readonly commonInvalidTokenError: ErrorMessage = new ErrorMessage(51, 'The token is invalid', 'commonInvalidTokenError');
  public static readonly commonUsedTokenErrorCode: number = 52;
  public static readonly commonUsedTokenError: ErrorMessage = new ErrorMessage(52, 'The token has been used', 'commonUsedTokenError');
  public static readonly commonExpiredTokenErrorCode: number = 53;
  public static readonly commonExpiredTokenError: ErrorMessage = new ErrorMessage(53, 'The token has expired', 'commonExpiredTokenError');
  public static readonly surveyQuestionSaveErrorCode: number = 101;
  public static readonly surveyQuestionSaveError: ErrorMessage = new ErrorMessage(101, 'Error saving question response', 'v2ErrorMessage_SaveQuestionResponseError');
  public static readonly participantValidationInvalidTokenErrorCode: number = 151;
  public static readonly participantValidationInvalidTokenError: ErrorMessage = new ErrorMessage(151, 'The participant token is invalid', 'participantValidationInvalidTokenError');
  public static readonly participantValidationUsedTokenErrorCode: number = 152;
  public static readonly participantValidationUsedTokenError: ErrorMessage = new ErrorMessage(152, 'The participant token has been used', 'participantValidationUsedTokenError');
  public static readonly participantValidationExpiredTokenErrorCode: number = 153;
  public static readonly participantValidationExpiredTokenError: ErrorMessage = new ErrorMessage(153, 'The participant token has expired', 'participantValidationExpiredTokenError');
  public static readonly respondentManagementDuplicateGroupNameErrorCode: number = 201;
  public static readonly respondentManagementDuplicateGroupNameError: ErrorMessage = new ErrorMessage(201, 'Duplicate group name', 'inviteRespondentsErrorDuplicateGroupName');
  public static readonly respondentManagementLoadGroupsErrorCode: number = 202;
  public static readonly respondentManagementLoadGroupsError: ErrorMessage = new ErrorMessage(202, 'Unable to load respondent groups', 'inviteRespondentsErrorLoadGroups');
  public static readonly respondentManagementIndexConflictErrorCode: number = 203;
  public static readonly respondentManagementIndexConflictError: ErrorMessage = new ErrorMessage(203, 'There is already a respondent at the request index number', 'inviteRespondentsErrorRespondentAtIndex');
  public static readonly respondentsValidationInvalidTokenErrorCode: number = 301;
  public static readonly respondentsValidationInvalidTokenError: ErrorMessage = new ErrorMessage(301, 'The respondent token is invalid', 'respondentValidationInvalidTokenError');
  public static readonly respondentsValidationUsedTokenErrorCode: number = 302;
  public static readonly respondentsValidationUsedTokenError: ErrorMessage = new ErrorMessage(302, 'The respondent token has been used', 'respondentValidationUsedTokenError');
  public static readonly respondentsValidationExpiredTokenErrorCode: number = 303;
  public static readonly respondentsValidationExpiredTokenError: ErrorMessage = new ErrorMessage(303, 'The respondent token has expired', 'respondentValidationExpiredTokenError');
  public static readonly selfRegistrationTokenValidationFailureErrorCode: number = 401;
  public static readonly selfRegistrationTokenValidationFailureError: ErrorMessage = new ErrorMessage(401, 'Ivalid token', 'errorHeaderTokenError');
  public static readonly impersonationValidationInvalidTokenErrorCode: number = 801;
  public static readonly impersonationValidationInvalidTokenError: ErrorMessage = new ErrorMessage(801, 'The impersonation token is invalid', 'impersonationValidationInvalidTokenError');
  public static readonly impersonationValidationUsedTokenErrorCode: number = 802;
  public static readonly impersonationValidationUsedTokenError: ErrorMessage = new ErrorMessage(802, 'The impersonation token has been used', 'impersonationValidationUsedTokenError');
  public static readonly impersonationValidationExpiredTokenErrorCode: number = 803;
  public static readonly impersonationValidationExpiredTokenError: ErrorMessage = new ErrorMessage(803, 'The impersonation token has expired', 'impersonationValidationExpiredTokenError');

  public static getErrorMessage(errorCode: number): ErrorMessage {
    type key = keyof typeof ErrorMessage

    for (let k in ErrorMessage) {
        if (typeof ErrorMessage[k as key] !== 'number') {
            const currentErrorMessage = ErrorMessage[k as key] as ErrorMessage;
            if (currentErrorMessage._errorCode === errorCode) return currentErrorMessage;
        }
    }

    return ErrorMessage.genericError;
  }
}
